import { Modal, Button } from "react-bootstrap";
import React from "react";

function ConfirmModal({
  show,
  handleClose,
  handleConfirmDeletion,
  selectedId,
  message,
  title
}) {
  return (
    <Modal show={show} onHide={handleClose}
      style={{ zIndex: 2000 }} // custom z-index

    >
      <Modal.Header closeButton>
        <Modal.Title>{title? title:"Confirm Deletion"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message?message:"Are you sure you want to delete this item?"}</Modal.Body>

      <Modal.Footer
        style={{ padding: "5px 12px", color: "white", fontSize: "14px" }}
      >
        <Button
          style={{ backgroundColor: "#30c6b7",width:'60px',height:'40px' }}
          variant="success"
          onClick={() => handleConfirmDeletion(selectedId)}
        >
          Ok
        </Button>
        <Button
          style={{ backgroundColor: "#ff7a00",width:'80px',height:'40px' }}
          variant="danger"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmModal;
